import React from 'react';
import { useSelectCurrentOrder } from 'selectors/order/selectCurrentOrder';
import OrderProgress from './OrderProgress';
import { useListSigningAppointmentsQuery } from '../../../../API/order/signingAppointment/SigningAppointmentAPI';
import { eConsumerTypes } from '../../../../types/order/consumer/eConsumerTypes';
import { ISigningAppointmentResponse } from '../../../../types/signingAppointment/ISigningAppointmentResponse';

export const OrderProgressContainer: React.FC = () => {
  const { data: order } = useSelectCurrentOrder();

  const { data: signingAppointments = [] } = useListSigningAppointmentsQuery({ orderId: order.transaction.id! });
  const borrowerAppointment = signingAppointments.find((apt: ISigningAppointmentResponse) => {
    return apt.ownerType === eConsumerTypes.borrower;
  });

  return <OrderProgress order={order} closingDate={borrowerAppointment?.appointmentDate as string} />;
};
